import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notiz"
export default class extends Controller {
	static targets = ["hiddenTagID", "headTag", "notiz", "notizSuchfeld"]

	connect() {}

	// ######################################################################
	// Setzt die Tag-ID ins Hidden-Field und faerbt den ausgewaehlten Tag ein
	// ######################################################################
	setzeTagID({ currentTarget }) {
		const selectedValue = currentTarget.dataset.value
		this.hiddenTagIDTarget.value = selectedValue
		this.faerbeNotiztag(selectedValue)
	}

	// ######################################################################
	// Faerbt den ausgewaehlten Tag ein und loest den Filter aus
	// ######################################################################
	filterNotiztag({ currentTarget }) {
		const selectedValue = currentTarget.dataset.value
		this.faerbeNotiztag(selectedValue)
		this.filterNotizen()
	}

	// ######################################################################
	// Filtert die Notizen (Notiztag und Sucheingabe)
	// ######################################################################
	filterNotizen() {
		const sucheingabe = this.notizSuchfeldTarget.value.toLowerCase()

		this.notizTargets.forEach((notiz) => {
			const notizinhalt = Array.from(notiz.querySelectorAll(".notizinhalt"))
				.map((e) => e.innerHTML)
				.join("")

			// Notiz ausblenden
			notiz.classList.add("hidden")

			// Den Tag der Notiz mit dem Tag des Filters vergleichen
			if (this.filterTag(this.headTagTarget.dataset.value, notiz.dataset.tag)) return
			// Den Notizinhalt mit der Sucheingabe vergleichen
			if (this.filterSuche(sucheingabe, notizinhalt)) return

			// Notiz wieder einblenden
			notiz.classList.remove("hidden")
		})
	}

	// private

	// ######################################################################
	// Faerbt im Formular und im Filter bei Auswahl das Notizlabel
	// ######################################################################
	faerbeNotiztag(selectedValue) {
		this.headTagTarget.classList.remove("ohne", "tagblue", "taggreen", "taglila", "tagorange")

		switch (selectedValue) {
			case "0":
				this.headTagTarget.classList.add("ohne")
				break
			case "1":
				this.headTagTarget.classList.add("tagblue")
				break
			case "2":
				this.headTagTarget.classList.add("taggreen")
				break
			case "3":
				this.headTagTarget.classList.add("taglila")
				break
			case "4":
				this.headTagTarget.classList.add("tagorange")
				break
		}

		// Wird nur beim Filtern benoetigt
		if (this.headTagTarget.hasAttribute("data-value")) {
			this.headTagTarget.dataset.value = selectedValue
		}
	}

	// ######################################################################
	// Filtertag = Notiztag -> false (wird nicht rausgefiltert)
	// ######################################################################
	filterTag(filtertag, notiztag) {
		if (filtertag == 0) {
			return false
		}
		return filtertag != notiztag
	}

	// ######################################################################
	// Notizinhalt enthält Sucheingabe -> false (wird nicht rausgefiltert)
	// ######################################################################
	filterSuche(sucheingabe, notizinhalt) {
		return !notizinhalt.toLowerCase().includes(sucheingabe)
	}
}
